// eslint-disable-next-line
import api from 'config';
import { EMPLOYEE_CARD_PAYMENT_AUTH_CODES, EMPLOYEE_CARD_PAYMENT_VISIBLE_COM_IDS } from 'constants/employeeCardPayment';

const menu = {
  depth1: [
    {
      name: 'Dashboard',
      code: '010',
      sort: 0,
      depth2: [],
      url: '/main/dashBoard',
      isShow: false,
      isOpen: true,
      isLink: false,
      authCode: ['meal-voucher:stat']
    },
    // {
    //   name: '이벤트',
    //   code: 81,
    //   sort: 1,
    //   url: '/main/event',
    //   isShow: false,
    //   isLink: true,
    //   depth2: []
    // },
    {
      name: '간식대장주문',
      code: '050',
      sort: 1,
      depth2: [],
      url: `${api.config.authAPI}/open/v1/auth/code?redirect_uri=${encodeURIComponent(api.config.godomall)}`,
      isShow: false,
      isOpen: false,
      isLink: false
    },
    {
      name: '식대관리',
      isShow: false,
      isOpen: true,
      code: '100',
      sort: 1,
      depth2: [
        {
          name: '우리회사 식대정책',
          code: 101,
          sort: 2,
          url: '/main/companySikdaePolicy',
          isShow: false,
          authCode: ['meal-policy:view', 'meal-policy:search', 'meal-policy:view', 'meal-policy:update'],
          excel: {
            isShow: false,
            url: '',
            method: ''
          },
          depth3: []
        },
        {
          name: '식대 지급/차감',
          code: 104,
          sort: 3,
          url: '/main/sikdaeGiveDeduct',
          isShow: false,
          authCode: ['meal-voucher:lower', 'meal-voucher:raise', 'meal-voucher:schedule'],
          excel: {
            isShow: false,
            url: '',
            method: ''
          },
          depth3: []
        },
        {
          name: '식대신청 승인/내역',
          code: 103,
          sort: 4,
          url: '/main/mealApproveList',
          isShow: false,
          authCode: ['meal-voucher:view'],
          excel: {
            isShow: true,
            url: '/coupon/v1/demand/download',
            method: 'get'
          },
          depth3: []
        },
        {
          name: '식대 내역',
          code: 102,
          sort: 5,
          url: '/main/sikdaeGivenList',
          isShow: false,
          authCode: [
            'meal-voucher:view',
            'meal-voucher:raise',
            'meal-voucher:lower',
            'meal-voucher:schedule',
            'meal-voucher:cancel'
          ],
          excel: {
            isShow: true,
            url: '/coupon/v1/task/download',
            method: 'get'
          },
          depth3: []
        },
        {
          name: '정산관리',
          code: 105,
          sort: 6,
          url: '/main/settlementList',
          isShow: true,
          authCode: [],
          depth3: []
        }
      ]
    },
    {
      name: '사용 내역',
      code: '200',
      isShow: false,
      isOpen: true,
      sort: 2,
      depth2: [
        {
          name: '사용자별 식대 내역',
          code: '201',
          sort: 1,
          url: '/main/userSikdaeGivenList',
          isShow: false,
          authCode: ['meal-voucher:view'],
          excel: {
            isShow: true,
            url: '/coupon/v1/user/download',
            method: 'get'
          },
          depth3: []
        },
        {
          name: '사용자별 잔여 식대',
          code: '208',
          sort: 8,
          url: '/main/remainingSikdae',
          isShow: false,
          authCode: ['meal-voucher:view'],
          excel: {
            isShow: true,
            url: '/member/v1/employee/download',
            method: 'get'
          },
          depth3: []
        },
        {
          name: '제휴식당 통계',
          code: '202',
          sort: 2,
          url: '/main/storeStats',
          isShow: false,
          authCode: ['meal-voucher:stat'],
          excel: {
            isShow: true,
            url: '/stat/v1/store/download',
            method: 'get'
          },
          depth3: []
        },
        {
          name: '사용자별 식대 사용내역',
          code: '202-1',
          sort: 2,
          url: '/main/userSikdaeUsageHistory',
          isShow: false,
          authCode: ['meal-voucher:view'],
          depth3: [],
          excel: {
            isShow: false,
            url: '',
            method: ''
          }
        },
        {
          name: '사용자별 식대 지급/차감',
          code: '202-2',
          sort: 2,
          url: '/main/userSikdaeGrandDeductHistory',
          isShow: false,
          authCode: ['meal-voucher:view'],
          depth3: [],
          excel: {
            isShow: false,
            url: '',
            method: ''
          }
        },
        {
          name: '부서 통계',
          code: '203',
          sort: 3,
          url: '/main/divisionStats',
          isShow: false,
          authCode: ['meal-voucher:stat'],
          excel: {
            isShow: true,
            url: '/stat/v1/company/division/download',
            method: 'get'
          },
          depth3: []
        },
        {
          name: '식대 그룹 통계',
          code: '204',
          sort: 4,
          url: '/main/sikdaeGroupStats',
          isShow: false,
          authCode: ['meal-voucher:stat'],
          excel: {
            isShow: true,
            url: '/stat/v1/company/group/download',
            method: 'get'
          },
          depth3: []
        },
        {
          name: '식대 사용 통계',
          code: '205',
          sort: 5,
          url: '/main/sikdaeUseStats',
          isShow: false,
          authCode: ['meal-voucher:stat'],
          excel: {
            isShow: true,
            url: '/stat/v1/company/coupon/download',
            method: 'get'
          },
          depth3: []
        },
        {
          name: '아워홈포인트 차감 통계',
          code: '205-2',
          sort: 5,
          url: '/main/ourhomeSubtractStat',
          authCode: ['meal-voucher:stat'],
          excel: {
            isShow: true,
            url: '/stat/v1/company/subtract/download',
            method: 'get'
          },
          depth3: []
        },
        {
          name: '삼성카드 급여공제',
          code: '205-1',
          sort: 5,
          url: '/main/salary-deduction',
          isShow: false,
          authCode: ['meal-voucher:stat'],
          excel: {
            isShow: true,
            url: '/stat/v1/company/samsung-card/salary-deduction/download',
            method: 'get'
          },
          depth3: []
        },
        {
          name: '삼성물산 급여공제',
          code: '205-3',
          sort: 5,
          url: '/main/salary-deduction-cnt',
          isShow: false,
          authCode: ['meal-voucher:stat'],
          excel: {},
          depth3: []
        },
        {
          name: '삼성의료재단 급여공제',
          code: '205-4',
          sort: 5,
          url: '/main/salary-deduction-medical',
          isShow: false,
          authCode: ['meal-voucher:stat'],
          excel: {
            isShow: true,
            url: '/stat/v1/company/samsung-medical/salary-deduction/download',
            method: 'get'
          },
          depth3: []
        },
        {
          name: '김앤장 급여공제',
          code: '205-5',
          sort: 5,
          url: '/main/salary-deduction-kimandchang',
          isShow: false,
          authCode: ['meal-voucher:stat'],
          excel: {
            isShow: true,
            url: '/stat/v1/company/kim-and-chang/salary-deduction/download',
            method: 'get'
          },
          depth3: [],
          isV2: true
        },
        {
          name: '식대 상세조회',
          code: '206',
          sort: 8,
          url: '/main/DetailedSikdae',
          isShow: false,
          authCode: ['meal-voucher:view'],
          excel: {
            isShow: true,
            url: '/coupon/v1/room/download',
            method: 'put'
          },
          depth3: []
        },
        {
          name: '식대 상세조회(PRO)',
          code: '206-1',
          sort: 6,
          url: '/main/DetailedSikdaePro',
          isShow: false,
          // TODO 신규 페이지 제공 회사 추가
          visibleCompanyIds: [
            'B068366F-5EB8-1C7E-E79C-D438C8E32F9D',
            '721C8B3F-1A9E-4B3E-855A-B7B8CE624167',
            '246AB769-F512-446D-B3A6-60DD0726AD35',
            '5FEC5FBB-AD6F-4FA0-80F8-445D5A892530',
            'F0C2775D-D815-458B-A2AD-71FFDDC24C2D'
          ],
          authCode: ['meal-voucher:view'],
          excel: {
            isShow: true,
            url: '/coupon/v1/room/download',
            method: 'put'
          },
          depth3: []
        },
        {
          name: 'SDS 식대 정책별 조회',
          code: '206-2',
          sort: 7,
          url: '/main/DetailedSikdaeSamsungSds',
          isShow: false,
          visibleCompanyIds: ['B068366F-5EB8-1C7E-E79C-D438C8E32F9D', '721C8B3F-1A9E-4B3E-855A-B7B8CE624167'],
          authCode: ['meal-voucher:view'],
          excel: {
            isShow: true,
            url: '/coupon/v1/room/download',
            method: 'put'
          },
          depth3: []
        },
        {
          name: '식대 결제사유 내역',
          code: '207',
          sort: 6,
          url: '/main/paymentReason',
          isShow: false,
          authCode: ['meal-voucher:cancel'],
          excel: {
            isShow: true,
            url: '/coupon/v1/user/reason/excel',
            method: 'get'
          },
          depth3: []
        },
        {
          name: '예약 현황',
          code: '405',
          sort: 5,
          url: '/main/bookingStatus',
          isShow: false,
          authCode: [],
          excel: {
            isShow: true,
            url: '/booking/v1/report/download',
            method: 'get'
          },
          depth3: []
        },
        {
          name: '예약 통계',
          code: '406',
          sort: 5,
          url: '/main/bookingStats',
          isShow: false,
          authCode: [],
          excel: {
            isShow: true,
            url: '/stat/v1/booking/download',
            method: 'get'
          },
          depth3: []
        }
      ]
    },
    {
      name: '회사 관리',
      code: '300',
      isShow: false,
      isOpen: true,
      sort: 3,
      depth2: [
        {
          name: '사용자 관리',
          code: '301',
          sort: 1,
          url: '/main/staffManagement',
          isShow: false,
          authCode: ['employee:view', 'employee:update', 'employee:create', 'employee:delete', 'employee:search'],
          excel: {
            isShow: false,
            url: '',
            method: ''
          },
          depth3: [
            {
              name: '사용자 정보 수정',
              code: '301-1',
              sort: 1,
              url: '/main/staffInfo',
              isShow: false,
              authCode: ['employee:update'],
              excel: {
                isShow: false,
                url: '',
                method: ''
              }
            }
          ]
        },
        {
          name: '예산 관리',
          code: '302',
          sort: 2,
          url: '/main/staffManagementMeal',
          isShow: false,
          authCode: ['budget:update'],
          excel: {
            isShow: false,
            url: '',
            method: ''
          },
          depth3: []
        },
        {
          name: '사용자 회원가입 관리',
          code: '303',
          sort: 3,
          url: '/main/signup',
          isShow: false,
          authCode: ['employee:create'],
          excel: {
            isShow: false,
            url: '',
            method: ''
          },
          depth3: []
        },
        {
          name: '회사 공지사항',
          code: '304',
          sort: 4,
          url: '/main/noticeList',
          isShow: false,
          authCode: ['notice:view'],
          excel: {
            isShow: false,
            url: '',
            method: ''
          },
          depth3: []
        },
        {
          name: '사용자 푸시메세지 전송',
          code: '305',
          sort: 5,
          url: '/main/pushMessage',
          isShow: false,
          authCode: ['notice:view'],
          excel: {
            isShow: false,
            url: '',
            method: ''
          },
          depth3: []
        },
        {
          name: '공휴일 관리',
          code: '306',
          sort: 6,
          url: '/main/holidayManagement',
          isShow: false,
          authCode: ['notice:view'],
          excel: {
            isShow: false,
            url: '',
            method: ''
          },
          depth3: [
            {
              name: '공휴일 수정',
              code: '306-1',
              sort: 1,
              url: '/main/holidayInfo',
              isShow: false,
              authCode: ['employee:update'],
              excel: {
                isShow: false,
                url: '',
                method: ''
              }
            }
          ]
        },
        {
          name: '사원증 결제 관리',
          code: '307',
          sort: 7,
          url: '/main/employeeCardPayment',
          isShow: false,
          // LIVE 는 지정 고객사만 노출, 그 외 환경은 전체 노출(undefined)
          visibleCompanyIds: EMPLOYEE_CARD_PAYMENT_VISIBLE_COM_IDS,
          // 사용자 관리(301)와 같은 기준 — employee 권한이 하나라도 있으면 노출한다.
          // 코드가 하나뿐이면 그 코드와 정확히 일치해야만 노출되어(helpers/commons 의 isMenuView)
          // employee:view 가 없는 권한 프리셋에서 메뉴가 사라진다.
          // 화면 진입 게이트도 같은 값을 쓴다(constants/employeeCardPayment).
          authCode: EMPLOYEE_CARD_PAYMENT_AUTH_CODES,
          excel: {
            isShow: false,
            url: '',
            method: ''
          },
          depth3: []
        }
      ]
    },
    {
      name: '기타 관리',
      code: '400',
      isShow: false,
      isOpen: true,
      sort: 4,
      depth2: [
        {
          name: '관리자 권한 관리',
          code: '401',
          sort: 1,
          url: '/main/accountManagement',
          isShow: false,
          authCode: [],
          excel: {
            isShow: false,
            url: '',
            method: ''
          },
          depth3: []
        },
        {
          name: '엑셀 다운로드 내역',
          code: '402',
          sort: 2,
          url: '/main/excelDownloadList',
          isShow: false,
          authCode: ['log:view'],
          excel: {
            isShow: false,
            url: '',
            method: ''
          },
          depth3: []
        },
        {
          name: '제휴식당 목록',
          code: '403',
          sort: 3,
          url: '/main/storeList',
          isShow: false,
          authCode: ['store:view'],
          excel: {
            isShow: false,
            url: '',
            method: ['store:search']
          },
          depth3: []
        },
        {
          name: '청구서 관리',
          code: '404',
          sort: 4,
          // url: "/main/bill?invoiced=March+1,+2018&account=3",
          url: '/main/bill',
          isShow: false,
          authCode: ['invoice:view'],
          excel: {
            isShow: false,
            url: '',
            method: ''
          },
          depth3: []
        }
      ]
    },
    {
      name: '식대 지급/차감 엑셀',
      code: '500',
      sort: 0,
      depth2: [],
      url: '/main/sikdaeGiveDeductByExcel',
      isShow: false,
      authCode: ['meal-voucher:lower', 'meal-voucher:raise', 'meal-voucher:schedule']
    }
  ]
};

export const service = {
  management: [
    {
      idx: 11,
      title: '대장마켓플레이스 관리',
      to: '/service/management/captainPayments',
      children: [
        { idx: 12, title: '서비스 이용 동의 현황', to: '/service/management/captainPayments/agreement/history' }
      ]
    },
    {
      idx: 8,
      title: '회사 관리',
      to: '/service/management/company',
      children: [
        { idx: 9, title: '사용자 관리', to: '/service/management/company/users' },
        { idx: 10, title: '회사 정보', to: '/service/management/company/info' },
        { idx: 32, title: '회사 공지사항', to: '/service/management/company/notice' },
        { idx: 33, title: '사용자 푸시메시지 발송', to: '/service/management/company/pushMessage' }
      ]
    }
  ],
  mro: [
    { title: '대장마켓플레이스 관리', children: [{ title: '서비스 이용 동의 현황' }] },
    { title: '회사 관리', children: [{ title: '사용자 관리' }, { title: '회사 정보' }] }
  ],
  quick: [
    {
      idx: 2,
      title: '퀵대장',
      children: [
        { idx: 14, title: '퀵 예약하기', to: '/service/quick/reservation/booking' },
        { idx: 1, title: '예약 및 내역', to: '/service/quick/reservation/list' },
        { idx: 3, title: '통계', to: '/service/quick/stats' },
        { idx: 13, title: '주소 관리', to: '/service/quick/address' },
        { idx: 37, title: '사용자 권한 관리', to: '/service/quick/permission' }
      ]
    },
    // { idx: 1, title: '예약하기', to: '/service/quick/reservation/booking' },
    {
      idx: 4,
      title: '퀵대장 관리',
      children: [
        { idx: 5, title: '서비스 안내', to: '/service/quick/landing' },
        { idx: 6, title: '서비스 이용 동의', to: '/service/quick/agreement' },
        { idx: 7, title: '서비스 메뉴얼', to: '/service/quick/manual' }
      ]
    }
  ],
  welfare: [
    {
      idx: 16,
      title: '복지포인트관리',
      children: [
        { idx: 17, title: '우리회사 복지그룹/정책', to: '/service/welfare/point/policy' },
        { idx: 18, title: '복지포인트 지급/차감하기', to: '/service/welfare/point/giveDeduct' },
        { idx: 34, title: '복지포인트 지급/차감내역', to: '/service/welfare/history/giveDeduct' }
      ]
    },
    {
      idx: 20,
      title: '거래 내역',
      children: [
        { idx: 21, title: '복지포인트 거래 내역', to: '/service/welfare/history/point' },
        { idx: 22, title: '사용자별 잔여 복지포인트', to: '/service/welfare/history/remaining' },
        { idx: 23, title: '사용처 통계', to: '/service/welfare/stats/used' },
        { idx: 36, title: '사용자별 복지포인트 사용통계', to: '/service/welfare/history/user' }
        // TBD { idx: 100, title: '부서 통계', to: '/service/welfare/stats/division' }
      ]
    },
    // {
    //   idx: 24,
    //   title: '회사 관리',
    //   children: [
    //     { idx: 25, title: '사용자 관리', to: '/service/welfare/company/employer' },
    //     { idx: 26, title: '회사 공지사항', to: '/service/welfare/company/notice' },
    //     { idx: 27, title: '사용자 푸시메시지 발송', to: '/service/welfare/company/pushMessage' }
    //   ]
    // },
    {
      idx: 28,
      title: '기타 관리',
      children: [{ idx: 29, title: '엑셀 다운로드 내역', to: '/service/welfare/history/excelDownload' }]
    },
    {
      idx: 30,
      title: '복지대장 관리',
      children: [{ idx: 31, title: '서비스 안내', to: '/service/welfare/landing' }]
    }
  ],
  flower: [],
  finance: [
    { idx: 35, title: '정산관리', children: [{ idx: 38, title: '정산관리', to: '/service/finance' }] },
    {
      idx: 39,
      title: '통계관리',
      children: [{ idx: 40, title: '직접정산 사용통계', to: '/service/finance/direct-payment-stats' }]
    }
  ]
};

export const getMenuIdx = (pathname) => {
  let menuIdx;

  const findRecursive = (parent, cb) => {
    cb(parent);
    if (parent.children) {
      parent.children.forEach((child) => {
        findRecursive(child, cb);
      });
    }
  };

  Object.keys(service).forEach((key) => {
    const s = service[key];
    s.forEach((ch) => {
      findRecursive(ch, (m) => {
        if (m.to === pathname) menuIdx = m.idx;
      });
    });
  });
  return menuIdx;
};

export default menu;
